<div class="language-picker">
  <div class="language-picker-header">
    <!-- This is hardcoded in english on purpose -->
    Select your preferred language
  </div>

  @if (currentLanguage$ | async; as currentLanguage) {
    @if (languages$ | async; as languages) {
      <div class="language-list">
        @for (language of languages; track language) {
          <button
            class="language"
            [ngClass]="{ selected: currentLanguage === language.languageCode }"
            (click)="chooseLanguage(language.languageCode)"
            >
            {{ language.name }}
          </button>
        }
      </div>
    }
  }
</div>
